import { Component, OnInit, Inject } from '@angular/core';
import { HomeService } from '../home.service';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.css']
})
export class OurTeamComponent implements OnInit {
  teams: any;
  constructor(@Inject(HomeService) private homeService: HomeService) { }

  ngOnInit() {

    this.homeService.getTeamData().subscribe((data: any) => {
      this.teams = data.teamsdata;
      // console.log(this.teams);
      // this.teams = [{
      //   'id': 71,
      //   'title': "Sandip Modi",
      //   'feature_image': "assets/images/team/sandeep_sir-1.jpg",
      //   'designation': "CEO"
      // }, {
      //   'id': 74,
      //   'title': "Riddhish Ojha",
      //   'feature_image': "assets/images/team/PM2.png",
      //   'designation': "Project Manager"
      // }, {
      //   'id': 77,
      //   'title': "Megh Makwana",
      //   'feature_image': "assets/images/team/HR.jpg",
      //   'designation': "HR Executive"
      // }];
    });
  }
}
